import React, { useState } from "react";
import "./Switch_Banner.css";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import Solar_Modal from "../../../common/solar-modal/Solar_Modal";

const Switch_Banner = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <section className="Switch_Banner">
        <div className="row">
          <div className="col-lg-7 col-md-7 p-0">
            <div className="Switch_Banner_content_holder">
              <h5 className="Switch_Banner_header">
                Ready to <span className="make_span">create your</span>{" "}
                <span className="switch"> Perfect Celebration?</span>
              </h5>

              <p className="Switch_Banner_text">
                Connect with our experts and turn your special moments into
                beautifully planned and memorable events.
              </p>
              <div
                className="Switch_Banner_btn_holder"
                onClick={() => setShowModal(true)}
              >
                <Common_Btn text={"Get Started"} />
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-md-5 p-0">
            <div className="Switch_Banner_img_holder">
              <img
                src="/assets/images/blogs/woman.png"
                alt=""
                className="Switch_Banner_img"
              />
            </div>
          </div>
        </div>

        <Solar_Modal show={showModal} handleClose={() => setShowModal(false)} />
      </section>
    </>
  );
};

export default Switch_Banner;
